//#region src/core/ui/volume-indicator/vars.ts
const VolumeIndicatorCSSVars = { 
/** Current predicted volume percentage, set on the Fill part. */
fill: "--media-volume-fill" };
//#endregion
export { VolumeIndicatorCSSVars };

//# sourceMappingURL=vars.js.map